export const iconFontAwesomeMoneyScaleUnbalancedFlip = (
	<i className="fa-solid fa-scale-unbalanced-flip"></i>
);
